import { ProductTypeSpec, SpecDisplay } from "../../types/prtoduct-type-specs";
import CheckboxFilter from "./checkbox-filter";
import RadiobuttonFilter from "./radiobutton-filter";
import SliderFilter from "./slider-filter";
import SearchBoxFilter from "./Search-box-filter";
import DropdownFilter from "./dropdown-filter";
export interface IFilterWrapperProps {
  spec: ProductTypeSpec;
  selectedValuesChanges: (selectedValues: string[]) => void;
  selectedRangeChanges: (selectedValues: number[]) => void;
}
export default function FilterWrapper({
  spec,
  selectedValuesChanges,
  selectedRangeChanges,
}: IFilterWrapperProps) {
  switch (spec.display) {
    case SpecDisplay.None:
      return null;
    case SpecDisplay.CheckBox:
      console.log("CheckBox.spec", spec);
      return (
        <CheckboxFilter
          title={spec.title}
          topics={spec.values}
          selectedValues={spec.selectedValues || undefined}
          onChange={selectedValuesChanges}
        />
      );
    case SpecDisplay.RadioButton:
      return (
        <RadiobuttonFilter
          title={spec.title}
          topics={spec.values}
          selectedValues={spec.selectedValues || undefined}
          onChange={selectedValuesChanges}
        />
      );
    case SpecDisplay.Slider:
      return (
        <SliderFilter
          title={spec.title}
          range={spec.range!}
          selectedRange={spec.selectedRange || spec.range!}
          onChange={selectedRangeChanges}
          specId={spec.id}
        />
      );
    case SpecDisplay.Search:
      return (
        <SearchBoxFilter
          title={spec.title}
          icon={spec.icon}
          onChange={(v) => selectedValuesChanges([v])}
        />
      );
    case SpecDisplay.DropDown:
     // console.log("spec.values", spec.values);
      return (
        <DropdownFilter
          title={spec.title}
          onChange={(v) => selectedValuesChanges([v])}
          icon={spec.icon}
          options={spec.values}
          selectedValues={spec.selectedValues}
        />
      );
    default:
      return null;
  }
}
